"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSponsorImageQuery = useSponsorImageQuery;
var _auth = require("@ori/auth");
var _axios = _interopRequireDefault(require("axios"));
var _axiosCaseConverter = _interopRequireDefault(require("axios-case-converter"));
var _swr = _interopRequireDefault(require("swr"));
var _contexts = require("../contexts");
const axiosClient = (0, _axiosCaseConverter.default)(_axios.default.create(), {
  // preserve keys in translations that represent locales, e.g. en-GB, ka-GE
  preservedKeys: input => /^[A-Za-z]{2}-[A-Za-z]{2}$/.test(input),
  caseFunctions: {
    camel: input => input.replaceAll(/\w\S*/g, val => `${val.charAt(0).toUpperCase()}${val.slice(1)}`)
  }
});
const getEncodedImage = blob => URL.createObjectURL(blob);
function useSponsorImageQuery(customerId, documentId) {
  const {
    globalApiUrl,
    tenant,
    currentLanguage
  } = (0, _contexts.useConfiguration)();
  const {
    formattedToken
  } = (0, _auth.useToken)();
  const shouldFetch = Boolean(customerId && documentId !== null && documentId !== undefined);
  const url = `${globalApiUrl}/customers/${customerId}/profileImages/${documentId}`;

  // Note: In future we can use generated client but blobs are currently not supported
  // const { data: profileImage } = useGetCustomerProfileImageDocument(customerId ?? 0, documentId ?? 0,
  //   {...imageSize}, undefined,
  //   {swr: { enabled: shouldFetch}, request: {responseType: 'blob'}});

  const {
    data: sponsorImage
  } = (0, _swr.default)(shouldFetch ? url.toString() : null, async requestUrl => {
    const headers = {
      'x-tenant-context': tenant,
      ...(currentLanguage && {
        'accept-language': currentLanguage
      })
    };
    headers.Authorization = formattedToken;
    const {
      data
    } = await axiosClient.get(requestUrl, {
      headers,
      responseType: 'blob'
    }).then(blob => blob).catch(error => error);
    return data;
  });
  return sponsorImage === undefined ? undefined : getEncodedImage(sponsorImage);
}
